export default {"src":"/_next/static/media/financial-statement-hero-blank1.df51fda8.svg","height":205,"width":175,"blurWidth":0,"blurHeight":0};